// extracted by mini-css-extract-plugin
module.exports = {"margin":"cards_margin__25jPQ","separator":"cards_separator__1t_ub","container":"cards_container__3tm7j"};